import {Box} from '@mui/material';
import {cloneDeep} from 'lodash';
import {GetServerSidePropsContext} from 'next';
import ErrorPage from 'next/error';
import {BlockRenderer} from '~/components/renderer/block-renderer';
import * as Types from '../../graphql/types';
import {getPageData} from '../[[...slug]]/index.page';
// import getListNew from './get-news-by-tag';
import Container from '@wearesection/bandai-react-components/atoms/Container';
import {useRouter} from 'next/router';
import {useCallback, useMemo, useState} from 'react';
import BlogCategoryComponent from '~/components/wrapper/organisms/blog-category';
import HomepageMashTheadOrganisms from '~/components/wrapper/organisms/home-page-mash-thead';
import VerticalScrollingLatestPostOrganisms from '~/components/wrapper/organisms/scrolling-infinity-latest-blog';
import TitleBlogFilter from '~/components/wrapper/organisms/title-blog-filter';
import {usePageSetting} from '~/providers/page-context.provider';
import {BLOCK_WRAPPER} from '~/styles/styles.constant';
import {handleConvertToLocaleContentful} from '~/utils';
import {handleGetDataBlogOnNews} from '~/utils/button-functions';
import {TABS_FILTER_BLOG} from '~/constants';

type PageGetNewsExt = {
  listTags: Types.TagsCollection;
  listTagsColor: any;
  data: any;
  locale: string;
};

const Blog = (props: PageGetNewsExt) => {
  const {data, locale} = props;
  const page = data?.pageCollection?.items[0];
  const router = useRouter();
  let tag = router.query?.tag || null;
  const [hideSection, SetHideSection] = useState<boolean>(false);
  const [isTagQuery, setIsTagQuery] = useState<boolean>(true);
  const [showSearch, setShowSearch] = useState<string[]>([]);
  const [numberValue, setNumberValue] = useState<number>(0);
  const {globalData} = usePageSetting();
  const listTagsColor = globalData?.listTagsColor ?? [];

  // Get Tag query
  if (typeof tag === 'string') {
    tag = tag.split('-');
  }
  if (!page) {
    return <ErrorPage statusCode={404} />;
  }
  const block: Array<any> = [page.sectionCollection?.items, page.seoStandard].filter(
    block => !!block
  );
  // Data of ScrollingThumbnailCard
  const blockCopy = cloneDeep(block);
  blockCopy[0].map((section: any, idx: number) => {
    blockCopy[0][idx].blocksCollection.items[0].listItemCollection = {
      ...blockCopy[0][idx]?.blocksCollection.items[0]?.listItemCollection,
      listTags: listTagsColor,
    };
  });

  // const subscribe = {
  //   __typename: 'SubscribePopup',
  // };

  const handleTitleMoreNew = () => {
    return '최신 블로그 기사';
  };

  const blockFilter = blockCopy[0].filter(
    (item: any) => item?.blocksCollection?.items[0]?.type === 'BlogFilter'
  );

  const blockMasthead = blockCopy[0].filter(
    (item: any) => item?.blocksCollection?.items[0]?.__typename === 'Mashthead'
  );

  const indexOfMasthead = blockCopy[0].findIndex(
    (item: any) => item?.blocksCollection?.items[0]?.__typename === 'Mashthead'
  );

  if (indexOfMasthead > -1) {
    blockCopy[0].splice(indexOfMasthead, 1);
  }

  const handleDetectTypeOfFilter = (value: string) => {
    const isTag = (TABS_FILTER_BLOG as string[])?.includes(value);
    if (typeof value === 'undefined') {
      setIsTagQuery(true);
    } else {
      if (isTag) {
        setIsTagQuery(true);
      } else {
        setIsTagQuery(false);
      }
    }
  };

  const handleConfirmIsFilter = (e: string[]) => {
    SetHideSection(e?.length ? true : false);
    handleDetectTypeOfFilter(e[0]);
    setShowSearch(e);
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const BlogCategoryComponentMemo = useMemo(
    () => (
      <BlogCategoryComponent
        {...blockFilter[0]?.blocksCollection.items[0]}
        handleConfirmIsFilter={handleConfirmIsFilter}
        queryTag={tag ?? []}
        listTagsColor={listTagsColor}
      />
    ),
    [JSON.stringify(tag), listTagsColor]
  );

  const getNumberValue = (e: number) => {
    setNumberValue(e);
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const VerticalScrollingLatestPostOrganismsMemo = useCallback(
    () => (
      <VerticalScrollingLatestPostOrganisms
        locale={handleConvertToLocaleContentful(locale as string)}
        title={''}
        listThumbnail={[]}
        getNumberValue={getNumberValue}
        handlerScroll={handleGetDataBlogOnNews}
        dataQueryTags={showSearch ?? []}
      />
    ),
    [showSearch, JSON.stringify(tag)]
  );

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
      }}
    >
      {isTagQuery && (
        <HomepageMashTheadOrganisms {...blockMasthead[0]?.blocksCollection.items[0]} />
      )}
      {isTagQuery && <Container>{BlogCategoryComponentMemo}</Container>}
      {!isTagQuery && (
        <Container>
          <TitleBlogFilter
            title={blockFilter[0]?.blocksCollection.items[0]?.title ?? ''}
            tagQuery={`All posts tagged “${showSearch}”`}
            numberResult={numberValue}
          />
        </Container>
      )}

      {!!showSearch.length && (
        <Container>
          <Box
            sx={{
              paddingTop: {
                xs: isTagQuery ? '38px' : '4px',
                md: isTagQuery ? '74px' : '13px',
              },
              paddingBottom: BLOCK_WRAPPER.paddingBottom,
              '& .MuiContainer-root': {
                paddingLeft: '0px',
                paddingRight: '0px',
              },
            }}
          >
            <VerticalScrollingLatestPostOrganismsMemo />
          </Box>
        </Container>
      )}

      {!hideSection && (
        <Box>
          <BlockRenderer block={blockCopy} slug={page?.slug ?? '/'} />
          <Box
            id="auto-hidden"
            sx={{
              paddingTop: {
                xs: '72px',
                md: '140px',
              },
              paddingBottom: BLOCK_WRAPPER.paddingBottom,
            }}
          >
            <VerticalScrollingLatestPostOrganisms
              locale={handleConvertToLocaleContentful(locale as string)}
              title={handleTitleMoreNew()}
              listThumbnail={[]}
              handlerScroll={handleGetDataBlogOnNews}
            />
          </Box>
        </Box>
      )}
      {/* <BlockRenderer block={[subscribe]} /> */}
    </Box>
  );
};

export const getStaticProps = async (ctx: GetServerSidePropsContext) => {
  const preview = !!(process && process.env && process.env.NEXT_PUBLIC_PREVIEW);

  const promises: [ReturnType<typeof getPageData>] = [getPageData({slug: 'blog', preview}, ctx)];
  const [pageData] = await Promise.all(promises);
  const {data} = pageData;
  const page = data?.pageCollection?.items[0];

  if (
    !page ||
    handleConvertToLocaleContentful(ctx.locale as string)?.toLocaleLowerCase() !== 'ko-kr'
  ) {
    return {
      notFound: true,
    };
  }
  return {
    props: {
      data,
      locale: ctx?.locale,
    },
    revalidate: 60 * 5,
  };
};
export default Blog;
